import type { getSearchVariables } from '../getSearchVariables/getSearchVariables';

export const isHeniTagActive = ({
	variables,
}: {
	variables: ReturnType<typeof getSearchVariables>;
}) => !!variables['heni'];
